var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "h-screen flex w-full bg-img vx-row no-gutter items-center justify-center",
      style: { "background-image": "url(" + _vm.imagenFondo + ") !important" },
      attrs: { id: "page-login" }
    },
    [
      _c(
        "vs-button",
        {
          staticClass: "logout-btn",
          attrs: {
            color: "primary",
            type: "filled",
            "icon-pack": "feather",
            icon: "icon-log-out",
            "data-cy": "logout-selector"
          },
          on: { click: _vm.logOut }
        },
        [_vm._v(" Cerrar sesión ")]
      ),
      _c("img", {
        style: _vm.logoStyle,
        attrs: { src: _vm.ingresoLogo.imagen, id: "logo" }
      }),
      _c(
        "div",
        {
          staticClass: "vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"
        },
        [
          _c("vx-card", [
            _c(
              "div",
              {
                staticClass: "full-page-bg-color",
                attrs: { slot: "no-body" },
                slot: "no-body"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vx-row no-gutter justify-center items-center"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "vx-col sm:w-full md:w-full lg:w-4/4 d-theme-dark-bg"
                      },
                      [
                        _c("div", { staticClass: "p-8 login-tabs-container" }, [
                          _c("div", { staticClass: "vx-card__title mb-10" }, [
                            _c("h4", { staticClass: "mb-4" }, [
                              _c("b", [_vm._v(_vm._s(_vm.currentUserAlias))]),
                              _vm._v(
                                ", por favor selecciona sobre cual organización quieres trabajar "
                              )
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("vs-divider"),
                              _c("vs-input", {
                                staticClass: "w-full",
                                attrs: {
                                  icon: "search",
                                  placeholder: "Buscar",
                                  "data-cy": "search"
                                },
                                model: {
                                  value: _vm.query,
                                  callback: function($$v) {
                                    _vm.query = $$v
                                  },
                                  expression: "query"
                                }
                              }),
                              _c("div", { staticClass: "mt-5" }, [
                                _vm._v(_vm._s(_vm.hiddenCompaniesMessage))
                              ]),
                              !!_vm.company && !!_vm.company.iut
                                ? _c("vs-divider")
                                : _vm._e(),
                              !!_vm.company && !!_vm.company.iut
                                ? _c(
                                    "vs-list",
                                    [
                                      _c(
                                        "vs-list-item",
                                        {
                                          key: _vm.company.iut,
                                          staticClass: "pt-3 pb-3 empresa",
                                          attrs: {
                                            title: _vm.company.fantasia,
                                            subtitle: _vm.company.razonSocial,
                                            "data-cy": "last-company-name"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.select(_vm.company)
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "vs-chip",
                                            { attrs: { color: "primary" } },
                                            [_vm._v("Ultima seleccionada")]
                                          ),
                                          _vm.company.canalDescripcion
                                            ? _c(
                                                "vs-chip",
                                                { attrs: { color: "success" } },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.company
                                                          .canalDescripcion
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "vs-chip",
                                            { attrs: { color: "warning" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatear(_vm.company.iut)
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("vs-divider"),
                              !_vm.companies.length
                                ? _c("h5", { staticClass: "text-primary" }, [
                                    _vm._v(
                                      " No tienes empresas asociadas, consulta con tu administrador "
                                    )
                                  ])
                                : _vm._e(),
                              _c(
                                "vs-list",
                                _vm._l(_vm.filteredCompanies, function(
                                  empresa
                                ) {
                                  return _c(
                                    "vs-list-item",
                                    {
                                      key: empresa.iut,
                                      staticClass: "pt-3 pb-3 empresa",
                                      attrs: {
                                        title: empresa.fantasia,
                                        subtitle: empresa.razonSocial,
                                        "data-cy": "company-name"
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.select(empresa)
                                        }
                                      }
                                    },
                                    [
                                      empresa.canalDescripcion
                                        ? _c(
                                            "vs-chip",
                                            { attrs: { color: "success" } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    empresa.canalDescripcion
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "vs-chip",
                                        { attrs: { color: "warning" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formatear(empresa.iut))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }